import { PageCreateModel, PageModel } from 'shared/models'
import * as Yup from 'yup'

function getValidations() {
  return Yup.object().shape({
    alias: Yup.string().required('Поле обязательно для заполнения'),
    name: Yup.string().required('Поле обязательно для заполнения')
  }) as Yup.ObjectSchema<NonNullable<PageModel | PageCreateModel>, Yup.AnyObject>
}

export { getValidations }
